<script setup>
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { computed, onMounted } from 'vue';
import IntegrationItem from './IntegrationItem.vue';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import { useAccount } from 'dashboard/composables/useAccount';

const store = useStore();
const getters = useStoreGetters();

const uiFlags = getters['integrations/getUIFlags'];
const { currentAccount } = useAccount();
const packageVersion = computed(() => {
  return currentAccount.value.package_version;
});

const integrationList = computed(
  () => getters['integrations/getAppIntegrations'].value
);

const DELUXE_VERSION = 4;
const showTip = computed(() => {
  // 只要不是豪华版都显示提示
  return (
    packageVersion.value !== DELUXE_VERSION && packageVersion.value !== '4'
  );
});

onMounted(() => {
  store.dispatch('integrations/get');
});
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.isFetching"
    :loading-message="$t('INTEGRATION_SETTINGS.LOADING')"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('INTEGRATION_SETTINGS.HEADER')"
        :description="$t('INTEGRATION_SETTINGS.DESCRIPTION')"
        :link-text="$t('INTEGRATION_SETTINGS.LEARN_MORE')"
        feature-name="integrations"
      />
    </template>
    <template #body>
      <div class="flex-grow flex-shrink overflow-auto">
        <template v-if="integrationList.length === 0">
          <div
            class="flex items-center justify-center h-64 text-slate-400 text-base"
          >
            {{ $t('INTEGRATION_SETTINGS.EMPTY_LIST') }}
          </div>
        </template>
        <template v-else>
          <div
            v-if="showTip"
            class="mb-4 mt-2 text-slate-400 text-base flex items-center"
          >
            {{ $t('INTEGRATION_SETTINGS.EMPTY_LIST') }}
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <IntegrationItem
              v-for="item in integrationList"
              :id="item.id"
              :key="item.id"
              :logo="item.logo"
              :name="item.name"
              :description="item.description"
              :enabled="item.enabled"
            />
          </div>
        </template>
      </div>
    </template>
  </SettingsLayout>
</template>
